import {
  INotificationSettingsForm,
  INotificationSettingsQuery,
  ICreateUserSpecification,
} from "services/configuration/notifications/types";

export const userSpecificationFormToQuery = (
  notificationForm: INotificationSettingsForm,
  userId: string
): ICreateUserSpecification => {
  const { mockedNotifications } = notificationForm;

  const notificationsArray: INotificationSettingsQuery[] = [];

  Object.keys(mockedNotifications).forEach((key) => {
    const domain = mockedNotifications[key];

    if (domain.notifications && Array.isArray(domain.notifications)) {
      const transformedNotifications = domain.notifications
        .filter((notification) => notification.isSelected)
        .map((notification) => ({
          notificationTypeId: notification.id,
          sendEmail: notification.sendEmail,
        }));

      notificationsArray.push(...transformedNotifications);
    }
  });

  return {
    userId,
    userSpecifications: notificationsArray,
  };
};
